import React from 'react';
import { Link } from 'react-router-dom';

export interface DataTableCellProps {
  Text: number | string;
  Url?: string;
  Width?: number;
  OpenInNewWindow?: boolean;
}

const DataTableCell = ({
  Text,
  Url = '',
  Width = null,
  OpenInNewWindow = undefined,
}: DataTableCellProps) => {
  if (Url !== '') {
    return (
      <td
        className="datatable-cell small p-0"
        width={Width !== null ? Width : null}
      >
        <Link
          target={OpenInNewWindow ? '_blank' : '_self'}
          className="datatable-cell-link text-black d-block p-16"
          to={Url}
        >
          {Text}
        </Link>
      </td>
    );
  }

  return (
    <td
      className="datatable-cell small p-16"
      width={Width !== null ? Width : null}
    >
      {Text}
    </td>
  );
};

// DataTableCell.defaultProps = {
//   Url: '',
//   Width: null,
//   OpenInNewWindow: undefined,
// };

export default DataTableCell;
export { DataTableCell };
